<template lang="pug">
  CrmLeadReminderListApi(v-if="leadId" :leadId="leadId")
</template>

<script>
import CrmLeadReminderListApi from '@/components/crm/CrmLeadReminderListApi.vue';

export default {
  name: 'CrmLeadReminderPopupWrappable',
  components: { CrmLeadReminderListApi },
  data() {
    return {
      leadId: null,
    };
  },
  methods: {
    init(params) {
      this.leadId = params.leadId;
    },
  },
};
</script>
